
type Props = {
    children: any,
    active: boolean
}

export function TabPane({ children, active }: Props) {
    return <div className={`tab-pane fade ${active && "show active"}`} id="on-sale" >
        {children}
    </div>
}